import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: 'Not found',
      redirect: '/error/404',
      component: () => import('@/views/Error')
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register')
    },
    {
      path: '/profile',
      name: 'profile',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Profile')
    },
    {
      path: '/success-register',
      name: 'success-register',
      component: () => import('@/views/SuccessRegister')
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('@/views/Search')
    },
    {
      path: '/article/:slug',
      name: 'article',
      component: () => import('@/views/Article')
    },
    {
      path: '/blog/:slug',
      name: 'blog',
      component: () => import('@/views/Blog')
    },
    {
      path: '/view/:id',
      name: 'View',
      component: () => import('@/views/View')
    },
    {
      path: '/view-organization/:id',
      name: 'View-Organization',
      component: () => import('@/views/ViewOrganization')
    },
    {
      path: '/my-organization',
      name: 'MyOrganization',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/MyOrganization')
    },
    {
      path: '/passport/:id',
      name: 'passport',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Passport')
    },
    {
      path: '/other-passport/:id',
      name: 'other-passport',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OtherPassport')
    },
    {
      path: '/oopt-description/:id',
      name: 'oopt-description',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptDescription')
    },
    {
      path: '/oopt-npa/:id',
      name: 'oopt-npa',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptNPA')
    },
    {
      path: '/oopt-targets-goals/:id',
      name: 'oopt-targets-goals',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptTargetsAndGoals')
    },
    {
      path: '/oopt-geography/:id',
      name: 'oopt-geography',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptGeography')
    },
    {
      path: '/oopt-biodiversity/:id',
      name: 'oopt-biodiversity',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptBiodiversity')
    },
    {
      path: '/oopt-inter-cooperation/:id',
      name: 'oopt-inter-cooperation',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptInterCooperation')
    },
    {
      path: '/oopt-gallery/:id',
      name: 'oopt-gallery',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptGallery')
    },
    {
      path: '/oopt-observe-plot/:id',
      name: 'oopt-observe-plot',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptObservePlot')
    },
    {
      path: '/oopt-observer/:id',
      name: 'oopt-observer',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptObserver')
    },
    {
      path: '/oopt-hunting-plot/:id',
      name: 'oopt-hunting-plot',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptHuntingPlot')
    },
    {
      path: '/passport-create',
      name: 'passport-create',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/CreatePassport')
    },
    {
      path: '/passport-other-create',
      name: 'passport-other-create',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/CreateOtherPassport')
    },
    {
      path: '/animals',
      name: 'animals',
      component: () => import('@/views/Animals')
    },
    {
      path: '/animals-class',
      name: 'animals-class',
      component: () => import('@/views/AnimalsClass')
    },
    {
      path: '/animal-view/:id',
      name: 'animal-view',
      component: () => import('@/views/AnimalView')
    },
    {
      path: '/flora',
      name: 'flora',
      component: () => import('@/views/Flora')
    },
    {
      path: '/flora-class',
      name: 'flora-class',
      component: () => import('@/views/FloraClass')
    },
    {
      path: '/flora-view/:id',
      name: 'flora-view',
      component: () => import('@/views/FloraView')
    },
    {
      path: '/reports/:id',
      name: 'reports',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Reports')
    },
    {
      path: '/report-create',
      name: 'report-create',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/CreateReport')
    },
    {
      path: '/report-view/:id',
      name: 'report-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/ReportView')
    },
    {
      path: '/account-card/:id',
      name: 'account-card',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/AccountCard')
    },
    {
      path: '/animal-accountings',
      name: 'animal-accountings',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/AccountCardList')
    },
    {
      path: '/account-card-view/:id',
      name: 'account-card-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/AccountCardView')
    },
    {
      path: '/account-card-map',
      name: 'account-card-map',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/AccountCardMap')
    },
    {
      path: '/map/:id?',
      name: 'map',
      component: () => import('@/views/MapOpenLayers')
    },
    {
      path: '/oopt-map-layers/:id',
      name: 'oopt-map-layers',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptMapLayers')
    },
    {
      path: '/zones/:id',
      name: 'zones',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Zones')
    },
    {
      path: '/plots/:id',
      name: 'plots',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Plots')
    },
    {
      path: '/quarters/:id',
      name: 'quarters',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Quarters')
    },
    {
      path: '/highlights/:id',
      name: 'highlights',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Highlights')
    },
    {
      path: '/objects/:id',
      name: 'objects',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Objects')
    },
    {
      path: '/object-gallery/:id',
      name: 'object-gallery',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/ObjectGallery')
    },
    {
      path: '/oopt-document/:id',
      name: 'oopt-document',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/OoptDocument')
    },
    {
      path: '/search-organizations',
      name: 'search-organizations',
      component: () => import('@/views/SearchOrganizations')
    },
    {
      path: '/research-work/:id',
      name: 'research-works',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/ResearchWork')
    },
    {
      path: '/summary-reports',
      name: 'summary-reports',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/SummaryReports')
    },
    {
      path: '/research-works',
      name: 'research-works',
      component: () => import('@/views/ResearchWorks')
    },
    {
      path: '/error/:status',
      name: 'error',
      component: () => import('@/views/Error')
    },
    {
      path: '/quota-applications',
      name: 'quota-applications',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/QuotaApplicationList')
    },
    {
      path: '/society/quota-applications/:id',
      name: 'society-quota-applications',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/SocietyQuotaApplicationList')
    },
    {
      path: '/society/quota-create/:id',
      name: 'society-quota-create',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/Create')
    },
    {
      path: '/society/quota-edit/:id',
      name: 'society-quota-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/SocietyEdit')
    },
    {
      path: '/quota-view/:id',
      name: 'quota-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/View')
    },
    {
      path: '/quota-allocate/:id',
      name: 'quota-allocate',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/Allocate')
    },
    {
      path: '/quota-refuse/:id',
      name: 'quota-refuse',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/Refuse')
    },
    {
      path: '/quotas',
      name: 'quotas',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/List')
    },
    {
      path: '/society/quotas/:id',
      name: 'society-quotas',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/SocietyList')
    },
    {
      path: '/society/quota-limits/:id',
      name: 'society-quota-limits',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/SocietyLimits')
    },
    {
      path: '/limits',
      name: 'limits',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/Limits')
    },
    {
      path: '/quota-cancellation',
      name: 'quota-cancellation',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/QuotaCancellation')
    },
    {
      path: '/quota-cancellation-edit/:id',
      name: 'quota-cancellation-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/QuotaCancellationEdit')
    },
    {
      path: '/quota-usage-standard',
      name: 'quota-usage-standard',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/UsageStandard')
    },
    {
      path: '/quota-usage-standard-create',
      name: 'quota-usage-standard-create',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/UsageStandardCreate')
    },
    {
      path: '/quota-usage-standard-edit/:id',
      name: 'quota-usage-standard-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/UsageStandardEdit')
    },
    {
      path: '/quota-cancellation-view/:id',
      name: 'quota-cancellation-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/quotas/QuotaCancellationView')
    },
    {
      path: '/bso-list',
      name: 'bso-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/List')
    },
    {
      path: '/bso-create',
      name: 'bso-create',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/Create')
    },
    {
      path: '/bso-invoice',
      name: 'bso-invoice',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/Invoice')
    },
    {
      path: '/department-bso-invoice/:id',
      name: 'department-bso-invoice',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/DepartmentInvoice')
    },
    {
      path: '/bso-invoice-edit/:id',
      name: 'bso-invoice-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/InvoiceEdit')
    },
    {
      path: '/bso-accounting',
      name: 'bso-accounting',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/Accounting')
    },
    {
      path: '/department-bso-accounting/:id',
      name: 'department-bso-accounting',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/bso/DepartmentAccounting')
    },
    {
      path: '/permit-reports',
      name: 'permit-reports',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/permitReport/List')
    },
    {
      path: '/society-permit-reports/:id',
      name: 'society-permit-reports',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/permitReport/SocietyList')
    },
    {
      path: '/permit-report-edit/:id',
      name: 'permit-report-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/permitReport/Edit')
    },
    {
      path: '/permit-report-show/:id',
      name: 'permit-report-show',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/permitReport/Show')
    },
    {
      path: '/society-license-application-list/:id',
      name: 'society-license-application-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/license/SocietyApplicationList')
    },
    {
      path: '/license-application-list',
      name: 'license-application-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/license/ApplicationList')
    },
    {
      path: '/license-application-view/:id',
      name: 'license-application-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/license/ApplicationView')
    },
    {
      path: '/license-application-edit/:id',
      name: 'license-application-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/license/Edit')
    },
    {
      path: '/license-application-refuse/:id',
      name: 'license-application-refuse',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/license/Refuse')
    },
    {
      path: '/license-issue-bso/:id',
      name: 'license-issue-bso',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/license/IssueBlankBso')
    },
    {
      path: '/count-summary-report-analytics',
      name: 'count-summary-report-analytics',
      component: () => import('@/views/analytics/CountSummaryReport')
    },
    {
      path: '/hunters-list',
      name: 'hunters-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/hunters/List')
    },
    {
      path: '/hunter-show/:id',
      name: 'hunter-show',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/hunters/Show')
    },
    {
      path: '/hunter-edit/:id',
      name: 'hunter-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/hunters/Edit')
    },
    {
      path: '/event-list',
      name: 'event-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/events/List')
    },
    {
      path: '/event-edit/:id',
      name: 'event-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/events/Edit')
    },
    {
      path: '/event-show/:id',
      name: 'event-show',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/events/Show')
    },
    {
      path: '/voucher-edit/:id',
      name: 'voucher-edit',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/vouchers/VoucherEdit')
    },
    {
      path: '/voucher-view/:id',
      name: 'voucher-view',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/vouchers/VoucherView')
    },
    {
      path: '/voucher-bsos',
      name: 'voucher-bsos',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/vouchers/Bsos')
    },
    {
      path: '/voucher-list',
      name: 'voucher-list',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/vouchers/VoucherList')
    },
    {
      path: '/notification',
      name: 'notification',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/Notification')
    },
    {
      path: '/success-notification',
      name: 'success-notification',
      meta: {
        layout: 'auth',
        requiresAuth: true
      },
      component: () => import('@/views/SuccessNotification')
    },
    {
      path: '/forrent',
      name: 'Forrent',
      component: () => import('@/views/Forrent')
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/views/support/Main')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    sessionStorage.setItem('redirectPath', to.path)
    next('/login')
  } else {
    next()
  }
})

export default router
